import React, { Children } from "react";
//main layout
import Footer from "./Footer/Footer";
import Header3 from "./Header/Header3";
import CookieTab from "../pages/PrivacyPolicy/CookieTab";

const mainLayout = (props) => {
  const pathname = window.location.pathname;

  return (
    <>
      <Header3 />
      {props.children}
      <CookieTab />
      <Footer />
    </>
  );
};

export default mainLayout;
